export const getLat = (lat) => {
  if (!lat || isNaN(lat)) return 19.393015;
  return Number(lat);
};

export const getLng = (lng) => {
  if (!lng || isNaN(lng)) return -99.173026;
  return Number(lng);
};
